// ======================================================================
// File Name       : LiveReservedUserAttributeList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';

class LiveReservedUserAttributeList extends React.Component {
  render() {
    const { userAttributeList } = this.props;
    return (
      <div>
        <Form className="margin-top-10">
          {userAttributeList.map((item, index) => {
            const value = item.userAttribute;
            const keyNum = item.userAttributeKeyNum;
            return value && (
              <Form.Group key={index} className="form-info">
                <Col as={Form.Label} sm={3}>
                  自由記述領域{keyNum}
                </Col>
                <Col as={Form.Label} sm={7}>{value}</Col>
              </Form.Group>
            );
          })}
        </Form>
      </div>
    );
  }
}

export default LiveReservedUserAttributeList;
